import { createContext } from "react";

export interface IGlobalOptions {
  whitelabel_color?: string;
  whitelabel_name?: string;
  whitelabel_darklogo?: string;
  whitelabel_lightlogo?: string;
  whitelabel_loginlogo?: string;
  openwebui_url?: string;
}

export interface IGlobalOptionsContext {
  globalOptions: IGlobalOptions;
  loading: boolean;
  error: Error | null;
  reload: () => void;
  name: string;
}

export const GlobalOptionsContext = createContext<IGlobalOptionsContext>({
  globalOptions: {
    whitelabel_color: "#FF0000",
    whitelabel_name: "Expedient",
    whitelabel_darklogo: "/logo-dark.png",
    whitelabel_lightlogo: "/logo-light.png",
    whitelabel_loginlogo: "/logo-light.png",
    openwebui_url: undefined,
  },
  loading: true,
  error: null,
  reload: () => {},
  name: "global options",
}); 